import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '$store';
import { toggleSelectedAssetId } from '~modules/media-library/controller/thunks/contribute';

interface TeaserCheckboxProps {
  isHovering: boolean;
  assetId: string;
}

export function TeaserCheckbox({ isHovering, assetId }: TeaserCheckboxProps) {
  const data = useSelector((store: RootState) => store.contribute);
  const { selectedAssetIds } = data;

  const isChecked = selectedAssetIds.includes(assetId);

  const dispatch = useDispatch();

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(toggleSelectedAssetId(assetId));
  };
  return (
    <div
      className={clsx(
        'ml--teaser-actions flex justify-between gap-2 flex-shrink-0 absolute top-2 right-0',
        isHovering && 'z-10',
      )}
    >
      <button
        className={clsx(
          'w-5 h-5 border border-solid mr-1 mt-1 rounded focus:outline-none',
          isChecked ? 'bg-blue border-blue-600' : 'bg-white border-silver',
        )}
        onClick={handleButtonClick}
        aria-label={isChecked ? 'Deselect asset' : 'Select asset'}
      >
        {isChecked && (
          <svg className="w-3 h-3" viewBox="2 -2 22 20" style={{ fill: 'white' }}>
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        )}
      </button>
    </div>
  );
}
